<template>
    <div
        :class="{
            accordion: true,
            'accordion--no-hover': noHover,
            'accordion--no-transition': noTransition,
            'is-expanded': isExpanded,
        }"
    >
        <div class="accordion__wrapper">
            <button
                type="button"
                class="accordion__title ts--body ts-align--left ts-weight--400 color--grey-900"
                @click="toggle($event)"
            >
                <span v-html="title"></span>

                <figure class="accordion__arrow">
                    <icon name="generic-chevron-bottom" />
                </figure>
            </button>

            <div
                :class="{
                    accordion__description: true,
                    'accordion__description--text': isText,
                }"
            >
                <div class="accordion__description-inner">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '@v4/common/components/atoms/Icon';

/**
 * A component for displaying collapsable accordion.
 *
 * @version 4.0.0
 * @example ./examples/Accordion.md
 */
export default {
    name: 'Accordion',
    components: {
        Icon,
    },
    props: {
        /**
         * The title of the accordion.
         */
        title: {
            type: String,
            required: true,
        },
        /**
         * Specifies the accordion content type: true - if the content html contains only texts and false if it contains other html elements.
         */
        isText: {
            type: Boolean,
            default: true,
        },
        /**
         * Specifies if the accordion should be expanded by default or not.
         */
        expanded: {
            type: Boolean,
            default: false,
        },
        /**
         * Specifies if the accordion should toggle with transition or without.
         */
        noTransition: {
            type: Boolean,
            default: false,
        },
        /**
         * Specifies if the accordion should change the border color when hover or not.
         */
        noHover: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isExpanded: false,
        };
    },
    created() {
        this.isExpanded = this.expanded;
    },
    methods: {
        /**
         * Toggles the accordion when the title is clicked.
         *
         * @param {object} e click event object
         * @returns {undefined}
         *
         * @public
         */
        toggle(e) {
            const ANCHOR = 'a';

            if (e.target.nodeName.toLowerCase() === ANCHOR) {
                return;
            }

            this.isExpanded = !this.isExpanded;
        },
    },
};
</script>
